export default __webpack_public_path__ + "static/media/product-image-card.9bbd33c0.jpg";